import styled from "styled-components";
import TextField from "@mui/material/TextField";
import Container from "@mui/material/Container";
import { Link as RouterLink } from "react-router-dom";
import CommonButton from "components/common/ui/CommonButton";

export const LoginPageContainer = styled(Container)`
  display: grid;
  align-content: center;
`;

export const LoginTitle = styled.h1`
  margin-bottom: 0;
  font-size: 50pt;
  text-align: center;
  color: #78cbff;
`;

export const LoginTitleSub = styled.div`
  margin-bottom: 0.5em;
  padding-bottom: 0;
  font-size: 30pt;
  text-align: center;
  color: #78cbff;
`;

export const LoginTextField = styled(TextField)`
  margin: 6px auto;
  min-width: 350px;
  cursor: pointer;
`;

export const LoginButton = styled(CommonButton)`
  margin: 24px auto;
  min-width: 250px;
`;

export const LoginFooter = styled.footer`
  margin-top: 32px;
  text-align: center;
`;

export const FooterLink = styled.a`
  color: #777;
  font-size: 14px;
  &:hover {
    text-decoration: underline;
  }
`;

export const LoginPageLink = styled(RouterLink)`
  margin: 8px auto;
  color: #777;
  font-size: 14px;
  text-align: center;
  &:hover {
    text-decoration: underline;
  }
`;

export const LoginMessageText = styled.p`
  margin: 12px auto;
  max-width: 420px;
  text-align: center;
  color: #555;
`;

export const LanguageMenuCorner = styled.div`
  position: fixed;
  top: 16px;
  right: 16px;
`;
